"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fonts = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const medium_1 = __importDefault(require("../fonts/Rubik/medium"));
const regular_1 = __importDefault(require("../fonts/Rubik/regular"));
const Fonts = () => (react_2.default.createElement(react_1.Global, { styles: `
      @font-face {
        font-family: 'Rubik';
        font-stretch: normal;
        font-style: normal;
        font-weight: 400;
        src: local('Rubik Regular'), url('${regular_1.default}') format('truetype');
      }
      @font-face {
        font-family: 'Rubik';
        font-stretch: normal;
        font-style: normal;
        font-weight: 500;
        src: local('Rubik Medium'), url('${medium_1.default}') format('truetype');
      }
      ` }));
exports.Fonts = Fonts;
